/**
 * @file Phone authentication container.
 */

import PropTypes from 'prop-types';
import { compose } from 'redux';
import { withRouter } from 'react-router-dom';
import { withApollo } from 'react-apollo';

import PhoneAuth from '../../components/auth/PhoneAuth';
import { withStoreReferralAttributes } from '../../hooks/useStoreReferralAttributes';

const propTypes = {
  onLogin: PropTypes.func,
  introText: PropTypes.oneOfType([
    PropTypes.node,
    PropTypes.arrayOf(PropTypes.node),
    PropTypes.string,
  ]),
  verificationText: PropTypes.oneOfType([
    PropTypes.node,
    PropTypes.func,
    PropTypes.arrayOf(PropTypes.node),
    PropTypes.string,
  ]),
  className: PropTypes.string,
  resetStoreAfterLogin: PropTypes.bool,
  onSentPin: PropTypes.func,
};

const PhoneAuthContainer = compose(
  withRouter,
  withApollo,
  withStoreReferralAttributes,
)(PhoneAuth);

PhoneAuthContainer.propTypes = propTypes;

export default PhoneAuthContainer;
